/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Releases_Meta_DescriptionInputs */

const id_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irama bulanan dan tahunan dari judul baru yang mendarat di Epic Games Store.`)
};

const ms_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadens bulanan dan tahunan judul baharu yang mendarat di Epic Games Store.`)
};

const da_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlig og årlig kadence af nye titler der lander på Epic Games Store.`)
};

const de_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlicher und jährlicher Rhythmus neuer Titel im Epic Games Store.`)
};

const en_us2_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly and yearly cadence of new titles landing on the Epic Games Store.`)
};

const es_es2_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritmo mensual y anual de nuevos títulos que llegan a la Epic Games Store.`)
};

const es_mx2_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritmo mensual y anual de nuevos títulos que llegan a la Epic Games Store.`)
};

const fil_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buwanan at taunang dalas ng mga bagong title na dumarating sa Epic Games Store.`)
};

const fr_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rythme mensuel et annuel des nouveaux titres arrivant sur l'Epic Games Store.`)
};

const it_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadenza mensile e annuale dei nuovi titoli che arrivano sull'Epic Games Store.`)
};

const hu_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havi és éves ütem az Epic Games Store-ba érkező új címekről.`)
};

const nl_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijkse en jaarlijkse cadans van nieuwe titels die in de Epic Games Store verschijnen.`)
};

const no_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlig og årlig kadens av nye titler som lander på Epic Games Store.`)
};

const pl_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miesięczne i roczne tempo nowych tytułów pojawiających się w Epic Games Store.`)
};

const pt_br2_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadência mensal e anual de novos títulos chegando ao Epic Games Store.`)
};

const pt_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadência mensal e anual de novos títulos a chegar à Epic Games Store.`)
};

const ro_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadența lunară și anuală a noilor titluri care ajung pe Epic Games Store.`)
};

const fi_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusien nimikkeiden kuukausi- ja vuositahti Epic Games Storessa.`)
};

const sv_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månads- och årstakt av nya titlar som landar i Epic Games Store.`)
};

const vi_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhịp hàng tháng và hàng năm của các tựa game mới trên Epic Games Store.`)
};

const tr_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store'a gelen yeni oyunların aylık ve yıllık temposu.`)
};

const cs_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíční a roční kadence nových titulů na Epic Games Store.`)
};

const bg_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месечен и годишен ритъм на нови заглавия в Epic Games Store.`)
};

const ru_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячная и ежегодная частота выхода новых игр в Epic Games Store.`)
};

const uk_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щомісячна та щорічна динаміка нових релізів у Epic Games Store.`)
};

const ar_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإيقاع الشهري والسنوي للإصدارات الجديدة على Epic Games Store.`)
};

const hi_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store पर नए शीर्षकों की मासिक और वार्षिक दर।`)
};

const th_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จังหวะรายเดือนและรายปีของเกมใหม่บน Epic Games Store`)
};

const ja_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store の新規タイトルの月別・年別の頻度。`)
};

const zh_cn2_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏商城每月和每年的新游戏发布频率。`)
};

const zh_hant1_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲商城每月和每年的新遊戲發布頻率。`)
};

const ko_stats_releases_meta_description = /** @type {(inputs: Stats_Releases_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store에 새로 출시되는 타이틀의 월별 및 연별 추이입니다.`)
};

/**
* | output |
* | --- |
* | "Monthly and yearly cadence of new titles landing on the Epic Games Store." |
*
* @param {Stats_Releases_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_releases_meta_description = /** @type {((inputs?: Stats_Releases_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Releases_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_releases_meta_description(inputs)
	if (locale === "ms") return ms_stats_releases_meta_description(inputs)
	if (locale === "da") return da_stats_releases_meta_description(inputs)
	if (locale === "de") return de_stats_releases_meta_description(inputs)
	if (locale === "en-US") return en_us2_stats_releases_meta_description(inputs)
	if (locale === "es-ES") return es_es2_stats_releases_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_stats_releases_meta_description(inputs)
	if (locale === "fil") return fil_stats_releases_meta_description(inputs)
	if (locale === "fr") return fr_stats_releases_meta_description(inputs)
	if (locale === "it") return it_stats_releases_meta_description(inputs)
	if (locale === "hu") return hu_stats_releases_meta_description(inputs)
	if (locale === "nl") return nl_stats_releases_meta_description(inputs)
	if (locale === "no") return no_stats_releases_meta_description(inputs)
	if (locale === "pl") return pl_stats_releases_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_stats_releases_meta_description(inputs)
	if (locale === "pt") return pt_stats_releases_meta_description(inputs)
	if (locale === "ro") return ro_stats_releases_meta_description(inputs)
	if (locale === "fi") return fi_stats_releases_meta_description(inputs)
	if (locale === "sv") return sv_stats_releases_meta_description(inputs)
	if (locale === "vi") return vi_stats_releases_meta_description(inputs)
	if (locale === "tr") return tr_stats_releases_meta_description(inputs)
	if (locale === "cs") return cs_stats_releases_meta_description(inputs)
	if (locale === "bg") return bg_stats_releases_meta_description(inputs)
	if (locale === "ru") return ru_stats_releases_meta_description(inputs)
	if (locale === "uk") return uk_stats_releases_meta_description(inputs)
	if (locale === "ar") return ar_stats_releases_meta_description(inputs)
	if (locale === "hi") return hi_stats_releases_meta_description(inputs)
	if (locale === "th") return th_stats_releases_meta_description(inputs)
	if (locale === "ja") return ja_stats_releases_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_releases_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_releases_meta_description(inputs)
	return ko_stats_releases_meta_description(inputs)
});
export { stats_releases_meta_description as "stats.releases.meta.description" }